/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from './totalAmount/totalAmount.component.ngfactory';
import * as i2 from '../../../../app/components/reports/totalAmount/totalAmount.component';
import * as i3 from '../../../../app/services/reportService';
import * as i4 from '@angular/router';
import * as i5 from '../../../../app/common/managers/storageManager';
import * as i6 from '../../../../app/services/configService';
import * as i7 from '../../../../app/components/reports/totalQuantityReport.component';
const styles_TotalQuantityReportComponent:any[] = ([] as any[]);
export const RenderType_TotalQuantityReportComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_TotalQuantityReportComponent,data:{}});
export function View_TotalQuantityReportComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'report-total-fee',
      ([] as any[]),(null as any),(null as any),(null as any),i1.View_TotalAmountComponent_0,
      i1.RenderType_TotalAmountComponent)),i0.ɵdid(114688,(null as any),0,i2.TotalAmountComponent,
      [i3.ReportService,i4.ActivatedRoute,i5.StorageManager,i6.ConfigService],{reportType:[0,
          'reportType']},(null as any))],(_ck,_v) => {
    var _co:i7.TotalQuantityReportComponent = _v.component;
    const currVal_0:any = _co.reportType.TotalQuantity;
    _ck(_v,1,0,currVal_0);
  },(null as any));
}
export function View_TotalQuantityReportComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'report-total-quantity-container',
      ([] as any[]),(null as any),(null as any),(null as any),View_TotalQuantityReportComponent_0,
      RenderType_TotalQuantityReportComponent)),i0.ɵdid(49152,(null as any),0,i7.TotalQuantityReportComponent,
      ([] as any[]),(null as any),(null as any))],(null as any),(null as any));
}
export const TotalQuantityReportComponentNgFactory:i0.ComponentFactory<i7.TotalQuantityReportComponent> = i0.ɵccf('report-total-quantity-container',
    i7.TotalQuantityReportComponent,View_TotalQuantityReportComponent_Host_0,{},{},
    ([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvcmVwb3J0cy90b3RhbFF1YW50aXR5UmVwb3J0LmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9FOi9EZXZlbG9wbWVudC9BSy9iYi1jb2RlL0JCLldlYi9hcHAvY29tcG9uZW50cy9yZXBvcnRzL3RvdGFsUXVhbnRpdHlSZXBvcnQuY29tcG9uZW50LnRzIiwibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvcmVwb3J0cy90b3RhbFF1YW50aXR5UmVwb3J0LmNvbXBvbmVudC5odG1sIiwibmc6Ly8vRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvcmVwb3J0cy90b3RhbFF1YW50aXR5UmVwb3J0LmNvbXBvbmVudC50cy5Ub3RhbFF1YW50aXR5UmVwb3J0Q29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPHJlcG9ydC10b3RhbC1mZWUgW3JlcG9ydFR5cGVdPVwicmVwb3J0VHlwZS5Ub3RhbFF1YW50aXR5XCI+PC9yZXBvcnQtdG90YWwtZmVlPiIsIjxyZXBvcnQtdG90YWwtcXVhbnRpdHktY29udGFpbmVyPjwvcmVwb3J0LXRvdGFsLXF1YW50aXR5LWNvbnRhaW5lcj4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7OztvQkNBQTtNQUFBO3dDQUFBLFVBQUE7TUFBQTtVQUFBOztJQUFrQjtJQUFsQixXQUFrQixTQUFsQjs7OztvQkNBQTtNQUFBOzZDQUFBLFVBQUE7TUFBQTs7OzsifQ==



// WEBPACK FOOTER //
// ./compiled/app/components/reports/totalQuantityReport.component.ngfactory.ts